
import customerRoutes from "@/modules/ReportView/components/Customer/router"
import locationRoutes from "@/modules/ReportView/components/Location/router"
import paymentRoutes from "@/modules/ReportView/components/Payments/router"
import daySummary from "@/modules/ReportView/components/DaySummary/router"
import monthlyTaxes from "@/modules/ReportView/components/MonthlyTaxes/router"
import serializedInventory from "@/modules/ReportView/components/SerializedInventory/router"
import quaterlyRoutes from "./components/QuaterlyTaxes/router"
// import invoiceRoutes from '@/modules/ReportView/components/invoice/router'
// import saleRoutes from '@/modules/ReportView/components/sale/router'
// import productRoutes from '@/modules/ReportView/components/Product/router'

const Index = () => import(/* webpackChunkName: "report" */ "./index.vue");
const MobileProfitAndLoss = () => import("./components/MobileProfitAndLoss.vue");
// import expenseRoutes from '@/modules/ReportView/components/expense/router'
// import paymentRoutes from '@/modules/ReportView/components/payment/router'


let childrenRoutes = []

childrenRoutes = childrenRoutes.concat(customerRoutes)
childrenRoutes = childrenRoutes.concat(locationRoutes)
// childrenRoutes = childrenRoutes.concat(profitRoutes)
// childrenRoutes = childrenRoutes.concat(saleRoutes)
// childrenRoutes = childrenRoutes.concat(expenseRoutes)
childrenRoutes = childrenRoutes.concat(paymentRoutes)
childrenRoutes = childrenRoutes.concat(quaterlyRoutes)
childrenRoutes = childrenRoutes.concat(daySummary)
childrenRoutes = childrenRoutes.concat(monthlyTaxes)
childrenRoutes = childrenRoutes.concat(serializedInventory)
childrenRoutes.push({
  path: "mobile-profit-and-loss",
  name: "mobile-profit-and-loss",
  component: MobileProfitAndLoss,
})
// childrenRoutes = childrenRoutes.concat(productRoutes)


export default [{
  path: "/reportview",
  name: "report-view",
  component: Index,
  children: childrenRoutes,
}]
